import * as React from "react";
import {Box, Fade, Modal, Typography} from "@mui/material";
import {
  StyledButton, StyledButtonDates, StyledButtonLoading,
  StyledDivCalendar, StyledDivPrimaryCalendar, StyledDivSelectCalendar, StyledDivTextCalendar,
  StyledPaper
} from "./styles";
import {DateCalendar, DateField, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {ptBR} from "date-fns/locale";
import {Dispatch, SetStateAction} from "react";
import Toast from "../toast";

interface IProps {
  setInitialDate: Dispatch<SetStateAction<Date | null>>;
  initialDate: Date | null;
  setFinalDate: Dispatch<SetStateAction<Date | null>>;
  finalDate: Date | null;

  onClick(): void | any;
}


export default function RangedDatePicker(props: IProps) {

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  function handleDateChange() {
    if (isDateValid()) {
      props.onClick();
      setOpen(false);
    }
  }

  function handleDateByType(type: string, number: number) {
    const newDate = new Date(Date.now());

    let nextDay = newDate.getDate();
    let nextMonth = newDate.getMonth();
    let nextYear = newDate.getFullYear();

    if (type === "month") {
      nextMonth -= number;
    }
    if (type === "year") {
      nextYear -= number;
    }
    if (type === "day") {
      nextDay -= number;
    }

    if (nextMonth === 12) {
      nextMonth = 0; // January
      nextYear++;
    }
    newDate.setFullYear(nextYear, nextMonth, nextDay);
    props.setInitialDate(newDate);
  }

  function isDateValid(): boolean {
    if (props.initialDate === null || props.finalDate === null ||
      props.initialDate.toString() === "Invalid Date" ||
      props.finalDate.toString() === "Invalid Date") {
      Toast.error("Selecione datas validas para realizar a busca");
      props.setFinalDate(new Date(Date.now()));
      props.setInitialDate(new Date(Date.now() - 864e5));
      return false;
    }
    if (props.finalDate < props.initialDate) {
      Toast.error("A data final não pode ser menor que a data inicial");
      return false;
    }
    return true;
  }

  return (
    <>
      <Modal open={open}
             onClose={() => setOpen(false)}
             closeAfterTransition>
        <Fade in={open}>
          <StyledPaper>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <StyledDivPrimaryCalendar>
                <StyledDivTextCalendar>
                  <DateField size={"small"}
                             variant={"standard"}
                             label="Data Inicial"
                             value={props.initialDate}
                             onChange={(value) => props.setInitialDate(value)}/>
                  <DateField size={"small"}
                             variant={"standard"}
                             label="Data Final"
                             value={props.finalDate}
                             onChange={(value) => props.setFinalDate(value)}/>
                </StyledDivTextCalendar>
                <StyledDivCalendar>
                  <DateCalendar value={props.initialDate}
                                onChange={(value) => props.setInitialDate(value)}/>
                  <DateCalendar value={props.finalDate}
                                onChange={(value) => props.setFinalDate(value)}/>
                </StyledDivCalendar>

              </StyledDivPrimaryCalendar>
            </LocalizationProvider>
            <StyledDivSelectCalendar>
              <Box sx={{gap: 4, display: "flex", flexDirection: "column"}}>
                <Typography sx={{fontWeight: "bold", fontSize: "1.3rem"}}>Períodos :</Typography>

                <div>
                  <StyledButtonDates
                    onClick={() => handleDateByType("day", 7)} disableRipple={true} size={"small"}>
                    Última semana
                  </StyledButtonDates>
                  <StyledButtonDates
                    onClick={() => handleDateByType("month", 1)} disableRipple={true} size={"small"}>
                    Último mês
                  </StyledButtonDates>
                  <StyledButtonDates
                    onClick={() => handleDateByType("month", 3)} disableRipple={true} size={"small"}>
                    Últimos 3 meses
                  </StyledButtonDates>
                  <StyledButtonDates
                    onClick={() => handleDateByType("month", 6)} disableRipple={true} size={"small"}>
                    Últimos 6 meses
                  </StyledButtonDates>
                  <StyledButtonDates
                    onClick={() => handleDateByType("year", 1)} disableRipple={true} size={"small"}>
                    Último ano
                  </StyledButtonDates>
                </div>
              </Box>
              <StyledButtonLoading onClick={handleDateChange} type={"submit"}>Buscar</StyledButtonLoading>
            </StyledDivSelectCalendar>
          </StyledPaper>
        </Fade>
      </Modal>
      <StyledButton disableRipple={true} onClick={handleOpen}>
        {props.initialDate?.toLocaleDateString()} - {props.finalDate?.toLocaleDateString()}
      </StyledButton>
    </>
  );
}
